export const getTenantCodeByHostname = (hostname: string): string => {
  let tenantCode = process.env.MASA_ENVIRONMENT === 'local' ? 'dev' : ''
  if (hostname.includes('-')) tenantCode = hostname.substring(0, hostname.indexOf('-'))
  return tenantCode
}
